import lifecycle from 'recompose/lifecycle'

import GridView from './Grid'

const Grid = lifecycle({
  shouldComponentUpdate (nextProps) {
    if (nextProps.gridValues !== this.props.gridValues) return true
    if (nextProps.using.fromCell !== this.props.fromCell) return true
    if (nextProps.scope !== this.props.scope) return true
    return false
  },
})(GridView)

Grid.displayName = 'Grid'

export default Grid



// WEBPACK FOOTER //
// ./src/components/RangeEditor/Grid/index.js